(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Infinite-Marquee"] && !Shopify.designMode) return;
  try {
    
const marquee = document.getElementById('marqueeContent');
const originalHTML = marquee.innerHTML;

while (marquee.offsetWidth < window.innerWidth * 2) {
  marquee.innerHTML += originalHTML;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clarity-faq"] && !Shopify.designMode) return;
  try {
    
  var acc = document.getElementsByClassName("faq-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("faq-active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}

  } catch(e) { console.error(e); }
})();
})();
